import { NotificationGroup } from '@progress/kendo-react-notification'
import styled from 'styled-components'

export const GroupStyled = styled(NotificationGroup)({
  // Debajo de la cabecera fija ($header-height: 70px) para no superponerse a ella
  top: 'calc(70px + 0.75rem)',
  right: '1rem',
  position: 'fixed',
  zIndex: 99999,
  maxWidth: '21.875rem',
  gap: '0.625rem',
})
